<template>
    <transition name="sidebar-modal">
      <section class="sidebar-modal-wrapper"
               @click="close"
               @keyup.esc="close"
               tabindex="0"
               ref="modal"
      >
        <div class="sidebar-modal-wrapper-inner" @click.stop>
          <span class="sidebar-modal-close" @click="close"><i class="icon icon-close"></i></span>
          <header>
            <slot name="header" />
          </header>
          <main class="sidebar-modal-wrapper-content">
            <slot name="body" />
          </main>
        </div>
      </section>
    </transition>
</template>

<script>
    export default {
        name: "sidebar-modal",
        props: {
            processing: Boolean,
        },
        data() {
            return {
                showContent: false,
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        },
        mounted() {
            // this.$refs.modal.focus();
        }
    }
</script>

<style lang="scss">
    @import "./../../../../scss/mixins/breakpoint";
    @import "./../../../../scss/variables";


    .sidebar-modal-wrapper {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: fixed;
      visibility: hidden;
      transition: visibility .3s ease-in-out;
      overflow: hidden;
      z-index: 1000;

      &::before {
        opacity: 0;
        content: '';
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        transition: 300ms;
      }

      &.visible {
        visibility: visible;

        &::before {
          opacity: 1;
        }

        .sidebar-modal-wrapper-inner {
          right: 0;
          text-align: left;

          .summary {
            right: 0;
          }
          .header {
            right: 0;
          }
        }
      }

      .sidebar-modal-close {
        cursor: pointer;
        float: right;
        font: {
          size: 20px;
        }
        margin: 30px 20px 0 20px;
        width: 23px;
        height: 23px;

        .icon-close::before {
          content: '';
          display: none;
        }
      }

      .sidebar-modal-wrapper-inner {
        background: white;
        width: 50%;
        max-width: 700px;
        height: 100vh;
        position: absolute;
        right: -100%;
        padding: 0 40px 40px 40px;
        overflow: hidden;
        overflow-y: scroll;
        transition: right 300ms ease-in-out;
        border-radius: 16px 0 0 16px;

        @include only-mobile-breakpoint() {
          border-radius: 0;
          height: 100vh;
          width: 100%;
          top: 0;
          padding: 0 20px 20px 20px;
        }

        .header {
          font-family: 'Fraunces', sans-serif;
          font-size: 28px;
          width: 50%;
          max-width: 700px;
          background-color: white;
          position: fixed;
          top: 0;
          right: -100%;
          text-align: left;
          padding: 30px 40px 0 40px;
          align-items: center;
          justify-content: center;
          transition: right 300ms ease-in-out;
          z-index: 1;
          border-radius: 16px 0 0 0;

          @include only-mobile-breakpoint() {
            border-radius: 0;
            font-size: 20px;
            width: 100%;
            padding: 20px;
          }
        }
      }

      @include only-mobile-breakpoint() {
        top: 0;

        .cart-poup {
          top: 0;
        }
      }

      header {
        text-align: left;
        font-size: 18px;
        color: #1E1E1E;
        font-weight: normal;
        padding: 30px 0 20px 0;
        background: #ffffff;

        span.small {
          font-family: Helvetica, sans-serif;
          font-size: 16px;
        }

        @include only-mobile-breakpoint {
          padding: 30px 0 10px 0;
          font-size: 18px;
        }

        .modal-name {
          font-family: 'Fraunces', sans-serif;
          font-size: 28px;
          margin-bottom: 10px;
          @include only-mobile-breakpoint {
            font-size: 18px;
          }
        }
      }

      .sidebar-modal-wrapper-content {
        background: #ffffff;
        padding: 0;
        .message {
          font-size: 14px;
          line-height: 150%;
          ul {
            list-style: disc;
            box-sizing: border-box;
            margin: 0 0 10px 10px;
            padding: 0 0 0 10px;
          }
        }
        .tab-header {
          padding: 2px 0 0 35px;
          background-image: url(../../../../images/icons/icon-detail.svg);
          background-position: left center;
          background-repeat: no-repeat;
          color: #212121;
          margin-bottom: 20px;
          font-weight: 700;
          font-size: 16px;
        }
        .association-item {
          width: 280px;
          height: auto;
        }
        @include only-mobile-breakpoint {
          padding: 0 0 20px 0;
        }
      }
    }

</style>
